<template>
  <div id="register">
    <div class="rshead">
      <!-- 头部视频 -->
      <div class="video">
        <video
          autoplay="autoplay"
          muted="muted"
          loop="loop"
          poster
          class="video-bg"
          >
        <source src="@/assets/images/r_kv.mp4" type="video/mp4">
        </video>
      </div>
      <!-- slogan -->
      <div class="slogan">
        <img class="re-title" src="@/assets/images/register/slg1.png" alt="">
        <img class="re-subtitle" src="@/assets/images/register/rsubtitle.png" alt="">
      </div>
      <img class="logo" src="@/assets/images/register/logo.png" alt="">
    </div>
    <div class="rsBottom">
      <!-- 邮箱 -->
      <div class="form">
        <input type="text" v-model="emailname" placeholder="メールアドレスを入力してください" class="emailname">
          <p class="notice" :class="{greenfont: applystatus}">{{errortext}}</p>
          <img class="rsemail" @click="registerFn" src="@/assets/images/register/rsemail.png" alt="">
          <div class="btn-wrap">

            <img class="twitter"
              @click="openLink('twitter_register_url')"
              src="@/assets/images/register/twitter.png"
              alt=""
              onclick="dataLayer.push({'event': 'click_to_twitter','event_label':'to_twitter'})"
            >
            <img class="line"
              @click="openLink('line_register_url');"
              src="@/assets/images/register/line.png"
              alt=""
              onclick="dataLayer.push({'event': 'click_to_line','event_label':'to_line'})"
            >
            <img class="japbtn"
              @click="openLink('japan_ios_qd_contrance')"
              src="@/assets/images/register/rbtn.png"
              alt=""
              onclick="dataLayer.push({'event': 'click_to_ten','event_label':'to_ten'})"
            >

          </div>
      </div>
      <!-- 下载按钮 -->
      <div class="down-wrap">
        <p class="down-box">
          <img class="ios"
            @click="iosFn"
            src="@/assets/images/register/ios.png"
            alt=""
            onclick="dataLayer.push({'event': 'click_to_ios','event_label':'to_ios'})"
          >
          <img class="google"
            @click="openLink('google')"
            src="@/assets/images/register/google.png"
            alt=""
            onclick="dataLayer.push({'event': 'click_to_google','event_label':'to_google'})"
          >
        </p>
      </div>
      <!-- 副标题 -->
      <div class="tedian backimgstyle" v-lazy:background-image="{ src: require('@/assets/images/register/tedian.png') }"></div>
      <!-- 人物立绘 -->
      <!-- <div class="girls backimgstyle"></div> -->
      <img class="girls" src="@/assets/images/register/girls.png" alt="">
      <div class="hero-card-box">
        <!-- 里程碑 -->
        <div class="card-wrap">
          <!-- 1,2 -->
          <div class="card-box top">
            <div
              v-for="(item, index) in [1,2]" :key="index"
              :class="'card'+index"
              class="card-item backimgstyle"
              :style="{backgroundImage: 'url(' + require('@/assets/images/register/card'+item+'.png') + ')'}">
              <span v-if="_myData.order && Number(_myData.order.level) >= item" class="cardfinish backimgstyle"></span>
            </div>
          </div>
          <!-- 3,4,5 -->
          <div class="card-box">
            <div
              v-for="(item, index) in [3,4,5]" :key="index"
              :class="'card'+index"
              class="card-item backimgstyle"
              :style="{backgroundImage: 'url(' + require('@/assets/images/register/card'+item+'.png') + ')'}">
              <span v-if="_myData.order && Number(_myData.order.level) >= item" class="cardfinish backimgstyle"></span>
            </div>
          </div>
        </div>
        <!-- 英雄立绘 -->
        <div class="hero backimgstyle" v-if="_myData.order" :style="{backgroundImage: 'url(' + _myData.order.painting + ')'}">
          <span class="finishicon backimgstyle" v-if="_myData.order && Number(_myData.order.level) >= 6"></span>
          <span class="hero-vioce" @click="openrsVideo">
            <i class="hvoice backimgstyle" :style="{backgroundImage: 'url(' + require('@/assets/images/register/horn_re_pc'+hersicon+'.png') + ')'}"></i>
          </span>
          <audio controls id="herorsaudio">
            <source src="@/assets/audio/Amaterasu.mp3" type="audio/mp3">
            <embed height="30" width="100" src="@/assets/audio/Amaterasu.mp3">
          </audio>
        </div>
      </div>

      <!-- 规则说明 -->
      <div class="rule backimgstyle">
        <span class="rule-jump2" @click="openLink('law_article_id')"></span>
      </div>
      <!-- 用户协议 -->
      <Pbottom></Pbottom>

    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { apply } from "@/proxy/index"
import Pbottom from "@/components/pc/Bottom1";
import { isPc } from "@/util/index"


export default {
  computed: {
    ...mapState(["_myData"]),
  },
  components: {
    Pbottom
  },
  watch: {
    emailname: {
      handler (val) {
        if(this.errortext) {
          this.setNotice(false, '')
        }
      },
      immediate: true
    }
  },
  created() {


  },
  mounted() {
    // this.setGirlsFn()
  },
  data() {
    return {
      emailname: '',
      errortext: '',
      applystatus: false,  //预约状态  false报错 true预约成功
      urldata: ['ios', 'google'],
      procaldata: ['law_article_id', 'rule_article_id'],
      girlstime: 0,
      girlspos: '',
      btnobj: {
        'google': 'g3',
        'twitter_register_url': 42,
        'line_register_url': 43,
        'japan_ios_qd_contrance': 44,
        'law_article_id': 330
      },
      hersicon: 2,
      voiceInterval: null,

      gtmobj: {
        'google': 'google',
        'twitter_register_url': 'twitter',
        'line_register_url': 'line',
        'japan_ios_qd_contrance': 'ten',
        'ios': 'ios',
        'email': 'email'
      }

    };
  },
  methods: {
    GAJumpSend(label) {
        const eventLabel = 'pc_' + this.gtmobj[label];
        gtag('event', 'x_click', {
            'event_label': eventLabel
        });
    },

    // 跳转链接
    openLink(code){

      if (code != 'law_article_id') {
        this.GAJumpSend(code);
      }

      let url = ''
      if (this.procaldata.indexOf(code) >= 0 ) {  //查看协议
        url = window.location.origin + '/protocol?id=' + this._myData.order[code];
      } else {
        url = this.urldata.indexOf(code) >=0 ? this._myData['submit_'+code] : this._myData.order[code]
      }
      window.open(url)
    },
    // ios按钮跳转
    iosFn () {
      this.GAJumpSend('ios');

      if (this._myData.submit_ios) {
        window.open(this._myData.submit_ios);
      } else {
        layer.open({
          content: 'まだ公開されていません。しばらくお待ちください。',
          time: 2,
          skin: 'msg'
        })
      }
    },
    // 注册
    registerFn() {

      const canRegister = this.FchkMail(this.emailname);
      if (canRegister && this.emailname) {
        const time = this.getCurrentTime();
        apply(this.emailname, time).then(res => {
          if (res.data.code == 0) {
            this.setNotice(true, '事前登録完了')  // 恭喜预约成功(重复预约同一邮箱不报错)
            dataLayer.push({'event': 'click_to_email','event_label':'to_email'});
            this.GAJumpSend('email');

          } else if (res.data.code == -20061) {
            this.emailname = '';
            setTimeout(()=>{
              this.setNotice(false, 'このメールアドレスは登録済みです')  // 邮箱重复输入。
            },0)
          } else {
            this.setNotice(false, '正しいメールアドレスを入力してください')  // 邮箱格式错误，请重新输入。
          }
        }).catch(() => {
            this.setNotice(false, 'Server error')  // Server error
        })
      } else {
        this.setNotice(false, '正しいメールアドレスを入力してください')  // 邮箱格式错误，请重新输入。
      }
    },

    // 提示信息
    setNotice(status, text) {
      this.applystatus = status;
      this.errortext = text;
    },

    // 邮箱验证
    FchkMail(mail){
      var szReg = /^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/
      const bchk = szReg.test(mail);
      return bchk;
    },

    // 获取当前时间 格式：yyyy-MM-dd HH:MM:SS
    getCurrentTime() {
      var date = new Date();//当前时间
      var month = this.zeroFill(date.getMonth() + 1);//月
      var day = this.zeroFill(date.getDate());//日
      var hour = this.zeroFill(date.getHours());//时
      var minute = this.zeroFill(date.getMinutes());//分
      var second = this.zeroFill(date.getSeconds());//秒
      //当前时间
      var curTime = date.getFullYear() + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
      return curTime;
    },
    // 补零
    zeroFill(i){
      if (i >= 0 && i <= 9) {
          return "0" + i;
      } else {
          return i;
      }
    },

    setGirlsFn(){
      const hehe = setInterval(()=>{
        this.girlstime++;
        if(this.girlstime >= 41){
          this.girlstime = 0;
        }
        this.girlspos = -796*this.girlstime + 'px';
      }, 70)
    },

    openrsVideo () {
      const audio = document.getElementById("herorsaudio");
      if (audio.paused) {
        audio.play();
      }
      audio.addEventListener("playing", ()=>{
        this.hersicon = 2;
        this.intervalFn();
      });
      audio.addEventListener("pause", ()=>{
        this.hersicon = 2;
        window.clearInterval(this.voiceInterval);
      });
    },

    intervalFn() {
      if (this.voiceInterval) {
        window.clearInterval(this.voiceInterval);
      }
      this.voiceInterval = setInterval(()=>{
        this.hersicon = this.hersicon == 1 ? 2 : 1;
      }, 300)
    }




  }
}
</script>

<style lang="scss">
@import "@/assets/scss/views/register.scss";
</style>
